import { lineClamp, clampVerticalTexts, isMobileDevice } from '@/functions';
import user from '@/user.js';

// Si el usuario es socio, eliminamos los ítems que contengan publi
if (user.isPartner) {
  document.querySelectorAll('#owlGallery .ad-modal').forEach((item) => {
    item.closest('.item').remove();
  });
}

/**
 * IMPORTANTE: La publicidad dentro de las fotogalerías lleva
 */
const carousel = document.getElementById('owlGallery');
if (carousel) {
  const itemTypeClass = isMobileDevice ? '.item_desktop' : '.item_mobile';
  carousel.querySelectorAll(itemTypeClass).forEach((el) => {
    el.remove();
  });
}

// Block drag if one slide:
const extraOwlCarouselOptions = {};
if ($('#owlGallery .item').length <= 1) {
  extraOwlCarouselOptions.mouseDrag = false;
  extraOwlCarouselOptions.touchDrag = false;
}

const owl = $('#owlGallery').owlCarousel({
  items: 1,
  dots: false,
  autoHeight: true,
  ...extraOwlCarouselOptions,
})
  // Gallery on change event
  .on('change.owl.carousel', function() {
    setTimeout(() => {
      const active = $('#owlGallery .owl-item.active');
      if (active.find('.item .ad-modal').length > 0) {
        $('.cmp-image-visor .gallery-info-wrapper').hide();
      } else {
        $('.cmp-image-visor .gallery-info-wrapper').show();
      }
    }, 10);
  })
  .on('prev.owl.carousel next.owl.carousel dragged.owl.carousel', function () {
    const id = $('.owl-item.active .item').data('id');
    if (id !== undefined) {
      window.dataLayer.push({
        event: 'click_image',
        eventData: {
          im_location: `secundaria_${id}`,
          content_id: window.appInfo?.contentId ?? undefined,
        },
      });

      window.location.hash = `#foto${id}`;
    }
  });

export {
  owl,
};

export default () => {
  const slideChangeDelay = 300;
  const maxMobileSize = 768;
  let windowWidth = window.innerWidth;

  // Close visor
  function closeVisor() {
    setTimeout(() => {
      $('body').css('overflow-y', 'auto');
    }, 1);
    owl.parents('.cmp-image-visor').hide(300);
    window.history.pushState('', document.title, window.location.pathname + window.location.search);
  }

  // Close event
  owl.find('.close-icon').off('click').click(function(e) {
    e.stopPropagation();
    closeVisor();
  });

  isVerticalSlide();

  // Dots active initialization:
  $('#owlGallery .owl-item .item').each(function(){
    var posText = $(this).find('.img-action-buttons .img-position').text()-1;
    $(this).find('.owl-dots.custom-dots .owl-dot').eq(posText).addClass('active');
  });

  // First load fix:
  setTimeout(() => {
    owl.trigger('refresh.owl.carousel');
  }, 1);

  /* EVENTS: */

  // Window resize event:
  $(window).resize(() => {
    windowWidth = window.innerWidth;

    if (windowWidth < maxMobileSize && !isMobileDevice) {
      $('.owl-item .item.vertical .img-container img').each(function(){
        $(this).parent().siblings('.img-info').css("max-height", "none");
        $(this).parent().siblings('.img-info').css("-webkit-line-clamp", "none");
      });

    }else if(windowWidth >= maxMobileSize){
      clampVerticalTexts('picture');
    }
  });

  // Dots click event:
  $('.custom-dots .owl-dot').off('click').click(function () {
    owl.trigger('to.owl.carousel', [$(this).index(), slideChangeDelay]);
  });

  // Arrow click event:
  $('.arrow-icon').off('click').click(function() {
    if($(this).hasClass('right')){
      owl.trigger('next.owl.carousel', [slideChangeDelay]);
    }else if($(this).hasClass('left')){
      owl.trigger('prev.owl.carousel', [slideChangeDelay]);
    }
  });

  $('.owl-item .img-container').click(function () {
    const owlItem = $(this).closest('.owl-item');
    if (
      owlItem.hasClass('active')
      && owlItem.find('.ad-modal').length < 1
    ) {
      const currentId = owlItem.find('.item').data('id');
      const numItems = $('#owlGallery .item').length;
      if (currentId < numItems) {
        owl.trigger('next.owl.carousel', [slideChangeDelay]);
      }
    }
  });

  // Key events:
  $(document).keyup(function(e) {
    switch(e.key) {
      case 'Escape':
        closeVisor();
        break;
      case 'ArrowLeft':
        owl.trigger('prev.owl.carousel', [slideChangeDelay]);
        break;
      case 'ArrowRight':
        owl.trigger('next.owl.carousel', [slideChangeDelay]);
        break;
    }
  });

  // Top close:
  $('.cmp-image-visor .visor-wrapper .gallery-info-wrapper .close-icon').off('click').click(function(e) {
    e.stopPropagation();
    closeVisor();

    const imageVisor = $(this).parents('.cmp-image-visor');
    const elIframe = imageVisor.find('.video-wrapper').html();
    imageVisor.find('.video-wrapper > *').remove();
    imageVisor.find('.video-wrapper').html(elIframe);

    const adHeaderRow = $(this).closest('.row').prev('.row');
    if (adHeaderRow.length) {
      setTimeout(() => {
        adHeaderRow.css({ display: 'flex' });
      }, 1);
    }
  });

  /* FUNCTIONS: */

  // skip-btn click event:
  $('.cmp-image-visor .skip-btn').off('click').click(function () {
    owl.trigger('next.owl.carousel', [slideChangeDelay]);
  });

  // Check if gallery active slide img is vertical:
  function isVerticalSlide(){
    $('.owl-item .item .img-container picture').each(function(){
      var item = $(this).parents('.item');

      if($(this)[0].height >= $(this)[0].width){
        item.addClass('vertical');
        if(windowWidth >= maxMobileSize){
          item.find('.img-info').css("max-height", $(this)[0].height);
          lineClamp(item.find('.img-info .img-description'), item.find('.img-info'));
        }
      }
    });
  }
};
